import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { sanitizeUrl } from "@braintree/sanitize-url";

/**
 * The placeholder sanitizeUrl() returns in place of a URL it rejects.
 */
const UNSAFE_URL = "about:blank";

/**
 * Validates a URL and marks it as trusted for use in a resource context (iframe src, etc).
 *
 * Returns null when the URL is missing or resolves to a dangerous scheme (javascript:, data:,
 * vbscript:, ...) so callers fail closed rather than embedding it.
 */
export function trustResourceUrl(sanitizer: DomSanitizer, url: string): SafeResourceUrl | null {
    if (sanitizeUrl(url) === UNSAFE_URL) {
        return null;
    }

    // Called indirectly: the URL has already been validated above
    const bypass = sanitizer.bypassSecurityTrustResourceUrl.bind(sanitizer);
    return bypass(url);
}
